import React, { FunctionComponent } from 'react'
import ComparisonData from '../../../entities/ComparisonData'
import ComparisonResultData from '../../../entities/ComparisonResultData'
import useTranslation from '../../../hooks/useTranslation'
import { Button } from '../../../base-components'
import style from './comparisonPdfButton.css'

export type Props = {
    comparisonData: ComparisonData
    resultData: ComparisonResultData
    onClick: () => void
}

const ComparisonPdfButton: FunctionComponent<Props> = (props) => {
    const { comparisonData, resultData, onClick } = props
    const { t } = useTranslation()

    const hasComparisonData = comparisonData && (
        (comparisonData.models?.length > 0 && comparisonData.models.some(m => m.modelId)) ||
        (comparisonData.codes?.length > 0 && comparisonData.codes.some(c => c.code))
    ) && resultData?.categories && resultData.categories.length > 0

    return (
        <Button
            variant="primary"
            onClick={onClick}
            disabled={!hasComparisonData}
            className={style.exportPdfButton}
        >
            {t('compare.exportPdfButtonText')}
        </Button>
    )
}

export default ComparisonPdfButton
